module.exports = __webpack_public_path__ + "img/avatar7.5cd409e6.png";